


















































































































import { Component, Vue } from 'vue-property-decorator';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';
import StBadge from '@/components/basic/StBadge.vue';
import { UpcomingPaymentsViewModel } from '@/services/api/nswag/stapiclient_generated';

@Component({
  components: { StBadge, StTabs, AccountSettingsInvoice },
})
export default class UpcomingPayments extends Vue {
  result: string = '';
  upcomingPayments: UpcomingPaymentsViewModel = UpcomingPaymentsViewModel.fromJS({dailyPayments: []});
  loading = true;

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    this.upcomingPayments = await stAdminApi.getUpcomingPaymentsViewModel();
    this.loading = false;
  }

  get dailyChart() {
    let data = {
      series: [
        {
          name: 'Euro',
          data: this.upcomingPayments?.dailyPayments?.map((entry) => entry.amount),
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar'
        },
        colors: ['#2980b9', '#5cb85c'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '50px',
          },
        },
        stroke: {
          width: [2, 3],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.upcomingPayments?.dailyPayments?.map((entry) => {
            return this.$options.filters?.formatDate(entry.date);
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            title: {
              text: 'Euro',
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          }
        ],
      },
    };

    return data;
  }

  get monthlyChart() {
    let data = {
      series: [
        {
          name: 'Euro',
          data: this.upcomingPayments?.monthlyPayments?.map((entry) => entry.amount),
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar'
        },
        colors: ['#2980b9', '#5cb85c'],
        plotOptions: {
          bar: {
            endingShapes: 'round',
            columnWidth: '50px',
          },
        },
        stroke: {
          width: [2, 3],
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.upcomingPayments?.monthlyPayments?.map((entry) => {
          return this.$options.filters?.formatDate(entry.date);
        }),
        xaxis: {
          type: 'string',
        },
        yaxis: [
          {
            title: {
              text: 'Euro',
            },
            labels: {
              formatter: (value: any) => {
                return this.$options.filters?.formatNumber(value);
              },
            },
          }
        ],
      },
    };

    return data;
  }
}
